import cookie from 'js-cookie'
import * as Lockr from 'lockr'

export function getCookie(name: string) {
  return cookie.get(name)
}

export function setCookie(name: string, value: string, options: Object = {}) {
  return cookie.set(name, value, options)
}

export function removeCookie(name: string, options: Object = {}) {
  return cookie.remove(name, options)
}

export function getLocalStorage(name: string) {
  return Lockr.get(name)
}

export function setLocalStorage(name: string, value: string) {
  return Lockr.set(name, value)
}

export function removeLocalStorage(name: string) {
  return Lockr.rm(name)
}
